import React from 'react'

export const TicketsDownload = React.lazy(
  () => import(/* webpackChunkName: "tickets-download-modal" */ '../modals/tickets-download'),
)
